/**
 * Created by OBL on 14-12-15.
 */
define('cataloguesMine',[
    'module',
    'logger',
    'cataloguesMainRouter'
], function(
    module,
    Logger
    ) {
    'use strict';

    var Catalogues = {
        start: function() {
            Logger.log(module, 'starting CataloguesMineModules');
        },

        stop: function() {
            Logger.log(module, 'stopping CataloguesMineModules');
        }
    };

    module.exports = Catalogues;
});
